module.exports = __webpack_public_path__ + "img/Adams.9316befd.jpg";